import { render } from "./PopUpSuggestContent.vue?vue&type=template&id=74405d9e"
import script from "./PopUpSuggestContent.vue?vue&type=script&lang=js"
export * from "./PopUpSuggestContent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__